module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-ford.07b82b5c.png";